(function () {
    /**
     * Call application component. It should be opened in a smaller popup window.
     * It mostly handles outgoing calls and connects users when they answer an incoming call.
     *
     * FIXME: Reloading the window ends call. OUTGOING window starts a new call after reload.
     *        It might be impossible to fix this without some flow changes, as we ware not able
     *        to detect if windows was closed vs reloaded
     *
     * FIXME?: Hide new call modal in call app popup window, so that you can't answer the call from withing call
     */
    angular.module('tradersyard').component('tyCallApp', {
        // language=HTML
        template:
            '<div class="ty-call-app" ng-switch="$ctrl.showView">\n\n    <div ng-switch-default class="modal-body">\n        Initializing...\n    </div>\n\n    <div ng-switch-when="view_denied">\n        <strong>{{$ctrl.meetingData.name}} has restricted the ability to call him</strong>\n    </div>\n\n    <div class="ty-call-app__view-timeout" ng-switch-when="view_timeout">\n        <strong>Could not initialize the call.</strong>\n        <ul>\n            <li>Are you trying to call from multiple clients at the same time?</li>\n            <li>The call server might be down.</li>\n        </ul>\n        <p>Please close all call windows and try calling again.</p>\n    </div>\n    \n    <div ng-switch-when="view_calling">\n        <ty-call-dialer\n                meeting-id="$ctrl.meetingData.id"\n                call-type="$ctrl.callType"\n                call-status="$ctrl.callStatus"\n                user-name="$ctrl.meetingData.name"\n                user-image="$ctrl.meetingData.photo.source"\n                on-close="$ctrl.closeCall()"\n                on-end-call="$ctrl.endCall()">\n        </ty-call-dialer>\n    </div>\n    \n    <div ng-switch-when="view_meeting" class="ty-call-app__view-meeting">\n        <ty-video-conference-app\n            meeting-id="$ctrl.meetingId"\n            enable-chat="true"\n            on-hangup="$ctrl.endCall()"\n            on-left-alone="$ctrl.leftAlone()">\n        </ty-video-conference-app>\n    </div>\n            \n</div>',
        bindings: {},
        controller: CallAppCtrl,
    });

    CallAppCtrl.$inject = [
        '$rootScope',
        'MeetingService',
        'graph-meeting-factory',
        'CallService',
        '$q',
        '$element',
        '$location',
        'WebSocket',
        '$window',
        '$timeout',
        'ChatCallNotifierService',
    ];

    function CallAppCtrl(
        $rootScope,
        MeetingService,
        meetingApi,
        CallService,
        $q,
        $element,
        $location,
        WebSocket,
        $window,
        $timeout,
        chatCallNotifierService
    ) {
        const ctrl = this;

        ctrl.showView = '';
        ctrl.VIEW_TIMEOUT = 'view_timeout';
        ctrl.VIEW_CALLING = 'view_calling';
        ctrl.VIEW_MEETING = 'view_meeting';
        ctrl.VIEW_DENIED = 'view_denied';

        ctrl.meetingData = {};
        ctrl.canMakeCall = true;

        /**
         * @type {string|"incoming"|"outgoing"}
         */
        ctrl.callType = '';

        /**
         *
         * @type {string|"connecting"|"calling"|"accepted"}
         */
        ctrl.callStatus = 'connecting';

        ctrl.$onInit = $onInit;

        ctrl.endCall = endCall;
        ctrl.closeCall = closeCall;
        ctrl.leftAlone = leftAlone;

        function $onInit() {
            const qs = $location.search();

            const params = {
                meetingId: qs.meeting_id,
                callType: qs.call_type,
            };

            WebSocket.onceConnectPromise().then(function () {
                initializeComponent(params);
            });

            // make sure we also end the call if we close the window
            _onWindowClosed(function () {
                CallService.rejectCall(params.meetingId);
            });
        }

        /**
         * Initialize component by loading meeting data and setting some helper flags.
         * @param {{meetingId: number, callType: string}} params
         */
        async function initializeComponent(params) {
            ctrl.meetingId = params.meetingId;
            ctrl.callType = params.callType;

            // Set an initialization timeout. Switch view after 5 seconds.
            $timeout(function () {
                // show only if we still haven't received a connect event
                if (!ctrl.showView) {
                    ctrl.showView = ctrl.VIEW_TIMEOUT;
                }
            }, 5000);

            // load info about the meeting and initialize some helper variables
            ctrl.meetingData = await getMeetingById(ctrl.meetingId);
            ctrl.isIncomingCall = ctrl.callType === CallService.CALL_INCOMING;
            ctrl.isOutgoingCall = ctrl.callType === CallService.CALL_OUTGOING;
            ctrl.canMakeCall = MeetingService.canMakeCallToUser(ctrl.meetingData);

            ctrl.isOutgoingCall ? initOutgoingCall() : initIncomingCall();
        }

        function initOutgoingCall() {
            if (!ctrl.canMakeCall) {
                ctrl.showView = ctrl.VIEW_DENIED;
                updateCallStatus('denied');
                return;
            }

            CallService.onceMeetingCallReconnect(ctrl.meetingId).then(function () {
                // the reconnect event is emitted for all clients.
                // we should not change the view if this is an active call client.
                if (ctrl.showView !== ctrl.VIEW_MEETING) {
                    ctrl.showView = ctrl.VIEW_TIMEOUT;
                }
            });

            // Show calling view after we connect to the call room
            CallService.onceMeetingCallConnect(ctrl.meetingId).then(function () {
                console.log('connect event emitted, showing call view');
                ctrl.showView = ctrl.VIEW_CALLING;
                updateCallStatus('calling');
            });

            CallService.createCall(ctrl.meetingId)
                .then(function () {
                    updateCallStatus('accepted');
                    initMeetingView();
                })
                .catch(function (e) {
                    ctrl.showView = ctrl.VIEW_CALLING;
                    updateCallStatus(e === 'meeting:call:timeout' ? 'unanswered' : 'rejected');
                });
        }

        /**
         * @param ('calling'|'accepted'|'rejected'|'ended'|'denied') status
         * @returns {any}
         */
        function updateCallStatus(status) {
            ctrl.callStatus = status;

            switch (status) {
                case 'calling':
                    return chatCallNotifierService.onCallStarted(ctrl.meetingId).then(({ data }) => {
                        ctrl.callEventId = data;
                    });
                case 'accepted':
                    return ctrl.callEventId && chatCallNotifierService.onCallAnswered(ctrl.callEventId);
                case 'rejected':
                    return ctrl.callEventId && chatCallNotifierService.onCallRejected(ctrl.callEventId);
                case 'unanswered':
                    return ctrl.callEventId && chatCallNotifierService.onCallUnanswered(ctrl.callEventId);
                case 'denied':
                    return ctrl.callEventId && chatCallNotifierService.onCallRejected(ctrl.callEventId);
            }
        }

        function initIncomingCall() {
            CallService.acceptCall(ctrl.meetingId).then(function () {
                updateCallStatus('accepted');
                initMeetingView();
            });
        }

        function initMeetingView() {
            // conference will be started by initializing <ty-video-conference-app /> component
            ctrl.showView = ctrl.VIEW_MEETING;
        }

        /**
         * Simply closes the window where <ty-call-app /> is running.
         * We are assuming we are inside a popup.
         */
        function closeCall() {
            console.log('closing window');
            $window.close();
        }

        /**
         * End call with CallService and then close the window of call-app.
         */
        function endCall() {
            CallService.rejectCall(ctrl.meetingId).finally(closeCall);
        }

        function leftAlone() {
            // A hacky workaround for how events work. Having a timeout will only run this for the person
            // that actually stayed in the conference alone. Otherwise the person who's leaving would also have this event called.
            // TODO: Do the timeout in video-conference-app?
            $timeout(() => {
                console.log('TY CALL APP you are the last man standing');
                ctrl.showView = ctrl.VIEW_CALLING;
                updateCallStatus('ended');
            }, 1000);
        }

        /**
         * Load meeting data by ID
         * @param meetingId
         * @returns {ng.IPromise<object>}
         */
        function getMeetingById(meetingId) {
            return meetingApi.getMeetingById(meetingId).then(function (response) {
                return response.data.data;
            });
        }

        function _onWindowClosed(cb) {
            $window.addEventListener('beforeunload', cb);
        }
    }
})();
